<irb-common-overlay #overlayComponent></irb-common-overlay>

<div class="dialog">
  <div mat-dialog-title>Settings</div>
  <mat-dialog-content>
    <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
    @if (!ps.isReady) {
      <div class='loading-spinner' style="width: 100%; height: 560px;"></div>
    }
    @if (ps.isReady) {
      <div style="position: relative;">
        @if (hasUnsavedChanges) {
          <div class="tabInterceptor" (click)="fireUnsavedChangesEvent($event)" style="position: absolute; z-index: 9999; width: 100%; height: 35px"></div>
        }
        <mat-tab-group style="clear: both;" animationDuration="0ms" dynamicHeight (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="index">
          <mat-tab label="Securities">
            <ng-template matTabContent>
              @if (!isUiTest) {
                <irb-settings-securities (closeModal)="close()"></irb-settings-securities>
              }
            </ng-template>
          </mat-tab>
          <mat-tab label="Accounts">
            <ng-template matTabContent>
              @if (!isUiTest) {
                <irb-settings-accounts [(onFirstLoad)]="onFirstLoad"></irb-settings-accounts>
              }
            </ng-template>
          </mat-tab>
          <mat-tab label="Portfolios">
            <ng-template matTabContent>
              @if (!isUiTest) {
                <irb-settings-portfolios (closeModal)="close()"></irb-settings-portfolios>
              }
            </ng-template>
          </mat-tab>
          <mat-tab label="Models">
            <ng-template matTabContent>
              @if (!isUiTest) {
                <irb-settings-models-rebalancing></irb-settings-models-rebalancing>
              }
            </ng-template>
          </mat-tab>
          <mat-tab label="Rebalancing">
            <ng-template matTabContent>
              @if (!isUiTest) {
                <irb-settings-logic></irb-settings-logic>
              }
            </ng-template>
          </mat-tab>
          <mat-tab label="Trading">
            <ng-template matTabContent>
              @if (!isUiTest) {
                <irb-settings-orders></irb-settings-orders>
              }
            </ng-template>
          </mat-tab>
          @if (isShowAutoTrading) {
            <mat-tab label="Automated Rebalancing"><!--6-->
              <ng-template matTabContent>
                @if (!isUiTest) {
                  <irb-settings-auto-trade></irb-settings-auto-trade>
                }
              </ng-template>
            </mat-tab>
          }
          @if (ps.hasAnyRole(['MMC_ADMIN'])) {
            <mat-tab label="MMC">
              <ng-template matTabContent>
                @if (!isUiTest) {
                  <irb-settings-mmc></irb-settings-mmc>
                }
              </ng-template>
            </mat-tab>
          }
          @if (ps.hasAnyRole(['MMC_ADMIN'])) {
            <mat-tab label="MMC Notes">
              <ng-template matTabContent>
                @if (!isUiTest) {
                  <irb-settings-mmc-notes></irb-settings-mmc-notes>
                }
              </ng-template>
            </mat-tab>
          }
          @if (ps.hasAnyRole(['MMC_ADMIN'])) {
            <mat-tab label="Announcements">
              <ng-template matTabContent>
                @if (!isUiTest) {
                  <irb-settings-announcements></irb-settings-announcements>
                }
              </ng-template>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    }
  </mat-dialog-content>
</div>
<irb-common-dialog #dialog></irb-common-dialog>
